export default () => {
  const termsAndConditions = document.querySelector('[data-attribute="terms-and-conditions"]');
  const mailingListSubmit = document.querySelector('[data-attribute="mailing-list-submit"]');

  if(termsAndConditions && contactForm) {

    termsAndConditions.addEventListener('click', evt => {
      if (termsAndConditions.checked) {
        mailingListSubmit.classList.remove('button--disabled');
        mailingListSubmit.disabled = false;

        return;
      }

      mailingListSubmit.classList.add('button--disabled');
      mailingListSubmit.disabled = true;
    });
  }
};



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/mailingList.js